import { Component, OnInit } from '@angular/core';
import {Helper} from '../../../app/utils/helper.module';

import { Location } from '@angular/common';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  url: string;
  modePro: boolean;
  logoName: string;

  constructor(private location: Location) {
    this.url = location.path();
    this.modePro = environment.pro;
   /* this.logoName = (this.modePro) ? 'logo-pro.png' : 'logo.png';*/
    this.logoName ='logo-pro.png';
  }

  ngOnInit() {
  }

}
